import { render, staticRenderFns } from "./TicketDetailsEditDialog.vue?vue&type=template&id=b7068e96&"
import script from "./TicketDetailsEditDialog.vue?vue&type=script&lang=ts&"
export * from "./TicketDetailsEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports